import {createAction, createAsyncThunk} from '@reduxjs/toolkit';
import {withPayloadType} from '@lib/utils';
import {AppThunkApiConfig} from '../../createStore';
import {AppUser} from '../../data/entities';
import {updateUser} from '../../data/user/actions';
import {setIsNewUserSession} from '../../data';
import {DayName, trackEvent} from '@lib/infrastructure';
import {NormalizedUserResult} from '../../infrastructure';

export const savePreferredBuilding = createAsyncThunk<
  NormalizedUserResult,
  {buildingId: string | null; isNew?: boolean; user?: AppUser},
  AppThunkApiConfig
>('ui/profile/savePreferredBuilding', async ({buildingId, isNew = false, user}, {dispatch}) => {
  dispatch(setIsNewUserSession(isNew));
  const updatedUser = {...(user ?? {}), defaultBuildingId: buildingId, isNew} as AppUser;
  const response = await dispatch(updateUser(updatedUser)).unwrap();

  trackEvent('UpdatePreferredBuilding');

  return response;
});

export const openPreferredBuildingSelection = createAction(
  'ui/profile/preferredBuildingSelectionOpened',
  withPayloadType<string>(),
);

export const selectPreferredBuilding = createAction('ui/profile/preferredBuildingSelected', withPayloadType<string>());

export const closePreferredBuildingSelection = createAction(
  'ui/profile/preferredBuildingSelectionClosed',
  withPayloadType<void>(),
);

export const savePreferredWorkdays = createAsyncThunk<void, DayName[], AppThunkApiConfig>(
  'ui/profile/savePreferredWorkdays',
  async (preferredWorkdays, {dispatch}) => {
    dispatch(setIsNewUserSession(true));

    const user = {preferredWorkdays};
    const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

    // TODO: Actual server request
    await sleep(500);
  },
);
